import * as React from 'react';
import Multiclamp from 'react-multi-clamp';
import styled from 'styled-components';

import LazyImage from 'crehana-ui/LazyImage';

const CourseCoverWrapper = styled.button`
  .course-cover-image {
    height: 82px;
    ${({ theme }) => theme.breakpoints.up('sm')} {
      height: 100px;
    }
    ${({ theme }) => theme.breakpoints.up('lg')} {
      height: 163px;
    }
  }
`;

type UpsellingCardProps = {
  url: string;
  title: string;
  promoImage: string;
  prices: {
    realPrice: number;
    currencySymbol: string;
  };
  trackRecommendationPosition?(): void;
};

const UpsellingCard: React.FC<UpsellingCardProps> = ({
  promoImage,
  prices,
  title,
  url,
  trackRecommendationPosition,
}) => {
  const redirectToAndTrack = () => {
    if (trackRecommendationPosition) {
      trackRecommendationPosition();
    }

    window.open(url, '_blank');
  };

  return (
    <div className="flex flex-col">
      <CourseCoverWrapper
        type="button"
        className="block w-full h-auto relative"
        onClick={redirectToAndTrack}
      >
        <LazyImage
          src={promoImage}
          alt={title}
          className="course-cover-image"
          imgClassName="object-cover"
        />
      </CourseCoverWrapper>
      <div className="mt-8 sm:mt-16">
        <div className="mb-8 font-subtitle3">
          <Multiclamp clamp={3} ellipsis="..." disableCssClamp>
            {title}
          </Multiclamp>
        </div>
        <p className="line-through text-gray-dark font-subtitle3">
          {`${prices.currencySymbol}${prices.realPrice.toLocaleString()}`}
        </p>
      </div>
    </div>
  );
};

export default UpsellingCard;
